import SelectableInput from "components/SelectableInput/SelectableInput";
import useAllTags from "hooks/useAllTags";
import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { callFunctionIfExists } from "utils/GeneralUtils";

const TagCreate = (
  { moduleAPIName, value, field, onChange, disabled },
  ref
) => {
  const selectRef = useRef();
  const [tags, setTags] = useState(Array.isArray(value) ? value : []);
  const { tagsLoading, tags: allTags, getTags } = useAllTags(moduleAPIName);

  const handleSelect = (tag) => {
    let newTags = [...tags, tag.id];

    callFunctionIfExists(onChange, field, newTags);
    setTags(newTags);
  };

  const handleDeselect = (tag) => {
    let newTags = tags?.filter((tagID) => tagID !== tag.id);

    if (newTags.length === 0) {
      newTags = "";
    }

    callFunctionIfExists(onChange, field, newTags);
    setTags(newTags);
  };

  const handleClear = () => {
    callFunctionIfExists(onChange, field, "");
    setTags([]);
  };

  useEffect(() => {
    if (value === "") return setTags([]);

    if (!Array.isArray(value)) return;

    setTags(value);
  }, [value]);

  useImperativeHandle(ref, () => ({
    focus: () => selectRef.current?.focus(),
  }));

  return (
    <SelectableInput
      ref={selectRef}
      options={allTags}
      loadingOptions={tagsLoading}
      value={getTags(tags)}
      disabled={disabled}
      labelKey="Name"
      valueKey="id"
      colorKey="Color"
      groupBy={["Scope", "Type"]}
      groupByLabels={{
        Person: "Your Tags",
        Cloud: "Cloud Tags",
        Module: "Module Tags",
        Workspace: "Workspace Tags",
      }}
      field={{ Name: "Tags", APIName: "Tags" }}
      nestedGroupBy="TagGroup"
      multiselect={true}
      maxValuesDisplayed={3}
      onSelect={handleSelect}
      onDeselect={handleDeselect}
      onClear={handleClear}
    />
  );
};

export default forwardRef(TagCreate);
